import CartLinkComponent, { CartLinkStyles } from "@husky-hrc/Components/CartLink";
import HuskyLogo from "@husky-hrc/Components/Icons/HuskyLogo";
import Save from "@husky-hrc/Components/Icons/Save";
import TactonConfigFooter from "@husky-hrc/Components/Tacton/TactonConfigFooter";
import TactonInput from "@husky-hrc/Components/TactonFormFields/TactonInput";
import cancelProductConfig from "@husky-hrc/Framework/Handlers/Data/ProductConfig/CancelProductConfig";
import commitProductConfig from "@husky-hrc/Framework/Handlers/Data/ProductConfig/CommitProductConfig";
import resolveProductConfig from "@husky-hrc/Framework/Handlers/Data/ProductConfig/ResolveProductConfig";
import startProductConfig from "@husky-hrc/Framework/Handlers/Data/ProductConfig/StartProductConfig";
import stepProductConfig from "@husky-hrc/Framework/Handlers/Data/ProductConfig/StepProductConfig";
import uncommitProductConfig from "@husky-hrc/Framework/Handlers/Data/ProductConfig/UncommitProductConfig";
import { getProductConfigStateByProductId } from "@husky-hrc/Framework/Store/Data/ProductConfig/ProductConfigSelectors";
import ExtendedApplicationState from "@husky-hrc/Framework/Store/ExtendedApplicationState";
import { GroupModel, ResponseModel, StepModel } from "@husky-hrc/Framework/Types/ApiModel";
import SkipNav from "@husky-hrc/Overrides/Components/SkipNav";
import Constants from "@husky-hrc/Utilities/Constants";
import { moveFocus } from "@husky-hrc/Utilities/Utilities";
import { createFromProduct } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TwoButtonModal, { TwoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import X from "@insite/mobius/Icons/X";
import ListItem, { UnorderedList } from "@insite/mobius/Lists";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Modal from "@insite/mobius/Modal/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { HasHistory, History, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    priceText = "priceText",
    leadTimeText = "leadTimeText",
    estimatedLeadTime = "estimatedLeadTime",
    rfqText = "rfqText",
    errorText = "errorText",
    formErrorText = "formErrorText",
    cssHideOrange = "cssHideOrange",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.priceText]: "string";
        [fields.leadTimeText]: "string";
        [fields.estimatedLeadTime]: "string";
        [fields.rfqText]: "string";
        [fields.errorText]: "string";
        [fields.formErrorText]: "string";
        [fields.cssHideOrange]: boolean;
    };
    preventGoingNextStep: boolean;
}

interface ConflictDetails {
    message: any;
    name: any;
    newValue: any;
}

export interface ProductConfigViewStyles {
    gridContainerStyles?: GridContainerProps;
    listContainerStyles?: InjectableCss;
    listItemStyles?: InjectableCss;
    huskyLogoStyles?: InjectableCss;
    cartLinkStyles?: CartLinkStyles;
    groupNavStyles?: TypographyPresentationProps;
    selectedItemStyles?: TypographyPresentationProps;
    groupStyles?: InjectableCss;
    groupItemStyles?: InjectableCss;
    navBarMobileHiddenStyles: HiddenProps;
    navBarMobileStyles?: InjectableCss;
    dropdownTextStyles?: InjectableCss;
    dropdownExitStyles?: ClickablePresentationProps;
    chevronIconStyles?: IconPresentationProps;
    mainContentContainerStyles?: GridContainerProps;
    stepTextStyles?: TypographyPresentationProps;
    groupDividerStyles?: InjectableCss;
    groupTextStyles?: TypographyPresentationProps;
    hiddenStyles?: InjectableCss;
    modalStyles?: TwoButtonModalStyles;
    cancelIcon?: ClickablePresentationProps;
    cancelIconMobileStyles?: IconPresentationProps;
    actionsContainerStyles?: InjectableCss;
    inputContainerStyles?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    saveContainer?: ClickablePresentationProps;
    saveIcon?: IconPresentationProps;
    saveText?: TypographyPresentationProps;
    errorMessageStyles?: TypographyPresentationProps;
}

export const productConfigViewStyles: ProductConfigViewStyles = {
    gridContainerStyles: {
        css: css`
            height: 100%;
            max-width: unset !important;
        `,
        gap: 0,
        offsetProps: {
            style: {
                height: "100%",
            },
        },
    },
    listContainerStyles: {
        css: css`
            height: 100%;
            width: 100%;
            list-style: none;
            background: ${getColor("common.accent")};
            padding: 30px 0 0 0;
            margin: 0;
            max-width: calc(100% / 6);
            position: fixed;
        `,
    },
    listItemStyles: {
        css: css`
            text-transform: uppercase;
            font-size: 16px;
            font-weight: 900;
            line-height: 24px;
            letter-spacing: 1.78px;
            margin: 30px 0;
            > ul {
                display: inline-block;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                padding: 0 24px;
                            `,
                            css`
                                padding: 0 60px;
                            `,
                        ],
                        "min",
                    )}
            }
        `,
    },
    huskyLogoStyles: {
        css: css`
            * {
                max-width: 100%;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            padding: 0 24px 30px 24px;
                        `,
                        css`
                            padding: 0 60px 30px 60px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    cartLinkStyles: {
        clickableLink: {
            css: css`
                // margin-left: auto;
                position: relative;
            `,
        },
    },
    groupNavStyles: {
        variant: "h4",
        forwardAs: "span",
        css: css`
            display: inline-block;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            padding: 0 24px 0 24px;
                            font-size: 14px;
                        `,
                        css`
                            @media (min-width: 1600px) {
                                font-size: 22px;
                                padding: 0 60px 0 60px;
                            }
                        `,
                    ],
                    "min",
                )}
        `,
    },
    selectedItemStyles: {
        variant: "h4",
        forwardAs: "span",
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 26px;
                            padding-right: 10px;
                        `,
                        null,
                        null,
                        css`
                            display: flex;
                            align-items: center;
                            width: 80%;
                            position: relative;
                            padding: 6px 0 6px 24px;
                            min-height: 65px;
                            background: ${theme.colors.primary.main};
                            font-size: 14px;

                            > span {
                                position: relative;
                                z-index: 2;
                            }

                            &:after {
                                content: "";
                                display: block;
                                position: absolute;
                                right: -13px;
                                width: 25px;
                                height: auto;
                                transform: skew(-10deg);
                                top: 0;
                                bottom: 0;
                                transition: transform 0.25s ease-in-out, background 0.25s ease-in-out;
                                background: ${theme.colors.primary.main};
                                z-index: 1;
                            }
                        `,
                        css`
                            @media (min-width: 1600px) {
                                font-size: 22px;
                                padding: 6px 20px 6px 60px;
                            }
                        `,
                    ],
                    "min",
                )}
        `,
    },
    groupStyles: {
        css: css`
            list-style: none;
            margin: 0;
            padding: 0;
            font-size: 15px;
            font-weight: normal;
            letter-spacing: 0;
            line-height: 34px;
            color: ${getColor("text.main")};
        `,
    },
    groupItemStyles: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 12px 0;
                        `,
                        null,
                        null,
                        css`
                            text-transform: capitalize;
                            margin: 10px 0;
                            padding: 0px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    navBarMobileHiddenStyles: {
        css: css`
            width: 100%;
            position: sticky;
            top: 0;
            z-index: 99;
            box-shadow: 0 0 12px 0 rgb(0 0 0 / 22%);
        `,
    },
    navBarMobileStyles: {
        css: css`
            width: 100%;
            background-color: ${getColor("common.disabled")};
            height: 56px;
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            z-index: 99;
            position: relative;
            display: flex;
            align-items: center;
        `,
    },
    dropdownTextStyles: {
        css: css`
            display: flex;
            align-items: center;
            flex-grow: 1;

            span:first-of-type {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 80%;
            }
        `,
    },
    dropdownExitStyles: {
        css: css`
            display: flex;
            align-items: center;
            padding-right: 26px;
            flex-shrink: 0;
            height: 100%;
        `,
    },
    chevronIconStyles: {
        size: 18,
        color: "danger.main",
        css: css`
            flex-grow: 1;
            justify-content: flex-end;
            flex-grow: 0;
        `,
    },
    mainContentContainerStyles: {
        gap: 30,
        css: css`
            outline: none;
            max-width: unset !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 30px 25px;
                            width: auto;
                        `,
                        null,
                        null,
                        css`
                            margin: 30px 65px 100px;
                            width: calc(100% - 130px);
                        `,
                    ],
                    "min",
                )}
        `,
    },
    stepTextStyles: {
        variant: "h5",
        forwardAs: "h1",
        css: css`
            margin-bottom: -30px;
        `,
    },
    groupDividerStyles: {
        css: css`
            > hr {
                background: ${getColor("text.main")};
                opacity: 40%;
                width: 100%;
            }
        `,
    },
    groupTextStyles: {
        variant: "h1",
        forwardAs: "h2",
        css: css``,
    },
    hiddenStyles: {
        css: css`
            display: none;
        `,
    },
    modalStyles: Constants.Styles.modalStyles,
    cancelIcon: {
        css: css`
            > span {
                background: ${getColor("danger")};
                color: ${getColor("danger.contrast")};
                justify-content: center;
                height: 41px;
                width: 41px;
                > svg {
                    height: 22px;
                    width: 21px;
                }
            }
            margin-left: 42px;
            margin-top: 5px;
        `,
    },
    cancelIconMobileStyles: {
        size: 21,
        css: css`
            margin-left: 5px;
        `,
    },
    actionsContainerStyles: {
        css: css`
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 13px 26px;
                            width: 100%;
                            z-index: 100;
                            background-color: white;
                            box-shadow: 0 0 12px 0 rgb(0 0 0 / 22%);
                        `,
                        null,
                        null,
                        css`
                            align-self: flex-end;
                            margin-top: 30px;
                            width: unset;
                            padding-top: 0;
                            box-shadow: none;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    inputContainerStyles: {
        css: css`
            align-items: flex-end;
        `,
    },
    loadingOverlay: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            flex-grow: 1;
            position: inherit;
        `,
        spinnerProps: {
            css: css`
                position: fixed;
                top: 50%;
                left: 50%;
            `,
        },
    },
    saveContainer: {
        css: css`
            margin-left: auto;
        `,
    },
    saveIcon: {
        src: Save,
        css: css`
            background: ${getColor("primary")};
            border-radius: 50%;
            justify-content: center;
            transition: all ease-in-out ${getProp("theme.transition.duration.short")}ms;
            :hover {
                background-color: ${getColor("primary.contrast")};
                border-color: ${getColor("primary.contrast")};
            }
            margin-right: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: 30px;
                            width: 30px;
                            > svg {
                                height: 10px;
                                width: 10px;
                            }
                        `,
                        null,
                        null,
                        css`
                            height: 52px;
                            width: 52px;
                            > svg {
                                height: 17px;
                                width: 17px;
                            }
                        `,
                    ],
                    "min",
                )}
        `,
    },
    saveText: {
        size: 14,
        weight: "bold",
        lineHeight: "17px",
        color: "text.main",
        css: css`
            margin-right: 30px;
        `,
    },
    errorMessageStyles: {
        variant: "p",
        color: "danger.main",
        weight: 600,
    },
};

const GroupItem = styled.span<{ current: boolean }>`
    cursor: pointer;
    &:focus {
        outline: 2px solid ${getProp("theme.focus.color")};
    }
    ${props =>
        props.current
            ? `
                font-weight: 900;
                &:before {
                    margin-right: .75em;
                    content: '\\2014';
                    color: #DE2C0F;
                }
            `
            : ""}
`;

const GroupItemMobile = styled.span<{ current: boolean }>`
    cursor: pointer;
    ${props => (props.current ? `color: ${props.theme.colors.common.accentContrast};` : "")}
`;

const GroupText = styled.div`
    &:focus {
        outline: 2px solid ${getProp("theme.focus.color")};
    }
`;

const NavList = styled.ul`
    background-color: ${getColor("common.disabled")};
    position: absolute;
    top: 56px;
    width: 100%;
    padding: 8px 26px;
    border-top: 1.2px solid #ccccd2;
    box-shadow: 0 4px 12px -4px rgb(0 0 0 / 22%);
`;

const mapStateToProps = (state: ExtendedApplicationState, ownProps: OwnProps) => {
    const location = getLocation(state);
    const query = parseQueryString<{ productId?: string; configId?: string; returnUrl?: string }>(location.search);
    const configId = query.configId || "";
    const productId = query.productId;
    const productConfigState = getProductConfigStateByProductId(state, productId);
    const product = getProductState(state, productId);
    const returnUrl = query.returnUrl || "/";
    const {
        fields: { priceText, leadTimeText, estimatedLeadTime, rfqText, errorText, formErrorText, cssHideOrange },
    } = ownProps;
    const cmsProps = { priceText, leadTimeText, estimatedLeadTime, rfqText, errorText, formErrorText, cssHideOrange };
    return {
        productId,
        configId,
        productConfigState,
        product,
        cmsProps,
        returnUrl,
    };
};

const mapDispatchToProps = {
    startProductConfig,
    stepProductConfig,
    commitProductConfig,
    cancelProductConfig,
    uncommitProductConfig,
    resolveProductConfig,
    setAddToListModalIsOpen,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const styles = productConfigViewStyles;

const onClick = (history: History, link: string | undefined) => {
    if (link) {
        history.push(link);
    }
};

type Validator = () => boolean;
type ContextType = {
    validators: {
        [key: string]: Validator | undefined;
    };
};

export const ProductConfigViewContext = React.createContext<ContextType>({
    validators: {},
});

const ProductConfigView: React.FC<Props> = ({
    productId,
    configId,
    productConfigState,
    product,
    returnUrl,
    startProductConfig,
    stepProductConfig,
    commitProductConfig,
    cancelProductConfig,
    uncommitProductConfig,
    resolveProductConfig,
    setAddToListModalIsOpen,
    cmsProps,
    history,
    preventGoingNextStep,
}) => {
    if (!productId) {
        return null;
    }

    const [cancelConfigurationModalVisible, setCancelConfigurationModalVisible] = React.useState(false);
    const [unsavedChanges, setUnsavedChanges] = React.useState(false);
    const [navigateLink, setNavigateLink] = React.useState("/");
    const [selectedStep, setSelectedStep] = React.useState<StepModel>({
        current: false,
        description: "",
        name: "",
        groups: [],
    });
    const [visibleSection, setVisibleSection] = React.useState<string | undefined>(undefined);
    const [hasConflict, setHasConflict] = React.useState(false);
    const [hasApiError, setHasApiError] = React.useState(false);
    const [hasUnknownError, setHasUnknownError] = React.useState(false);
    const [conflictDetails, setConflictDetails] = React.useState<ConflictDetails | undefined>();
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const [validators] = React.useState<{ [key: string]: Validator | undefined }>({});
    const [navOpen, setNavOpen] = React.useState(false);
    const [isAddingToCart, setIsAddingToCart] = React.useState(false);
    const [formError, setFormError] = React.useState(false);

    useEffect(() => {
        startProductConfig({
            productId,
            configId,
            onSuccess: onPageHasUnsavedChanges,
            onException: onApiError,
            onError: onUnknownError,
        });
    }, [productId, configId]);

    useEffect(() => {
        return () => {
            onAllChangesSaved();
        };
    }, []);

    useEffect(() => {
        if (productConfigState.value) {
            const selectedStep = productConfigState.value?.steps.find((step: StepModel) => step.current);
            if (selectedStep) {
                setSelectedStep(selectedStep);
                if (!visibleSection) {
                    setVisibleSection(selectedStep.groups[0].name);
                }
                if (productConfigState.value.response.changed) {
                    const conflict = productConfigState.value.response.changed[0];
                    const message = (
                        <>
                            {translate("To resolve your selection, the following parameters must be changed")}
                            <br />
                            <br />
                            <b>
                                {translate("Current")} {conflict.description}
                            </b>
                            : {conflict.oldValueDescription}
                            <br />
                            <b>
                                {translate("New")} {conflict.description}
                            </b>
                            : {conflict.newValueDescription}
                        </>
                    );
                    setConflictDetails({
                        ...conflict,
                        message,
                    });
                    setHasConflict(true);
                }
            }
        }
        window.scrollTo(0, scrollPosition);
        setFormError(false);
    }, [productConfigState.value]);

    useEffect(() => {
        const handleScroll = () => {
            const windowHeight = window.innerHeight;
            const windowWidth = window.innerWidth;
            const selected = refsArray.current.find(ref => {
                const { top, left, bottom, right, height } = getDimensions(ref);
                return top >= 0 && left >= 0 && bottom <= windowHeight && right <= windowWidth && height > 0;
            });

            if (selected && selected.id !== visibleSection) {
                setVisibleSection(selected.id);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [visibleSection]);

    useEffect(() => {
        if (formError) {
            onFormError();
        }
    }, [formError]);

    const dropdownRef = React.useRef<HTMLDivElement>(null);

    const refsArray = React.useRef<Array<HTMLDivElement>>([]);

    const getDimensions = (ele: HTMLSpanElement) => {
        const { top, left, bottom, right, height } = ele.getBoundingClientRect();

        return {
            top,
            left,
            bottom,
            right,
            height,
        };
    };

    const beforeUnloadListener = (e: BeforeUnloadEvent) => {
        e.preventDefault();
        e.returnValue = "";
    };

    const onPageHasUnsavedChanges = () => {
        setUnsavedChanges(true);
        window.addEventListener("beforeunload", beforeUnloadListener);
    };

    const onAllChangesSaved = () => {
        setUnsavedChanges(false);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    };

    const onApiError = (response: ResponseModel) => {
        if (!response?.changed) {
            setHasApiError(true);
        }
    };

    const onUnknownError = () => {
        setHasUnknownError(true);
    };

    const onUnknownErrorModalClose = () => {
        setHasUnknownError(false);
        setNavigateLink(returnUrl);
        cancelProductConfigurationClick();
    };

    const onFormError = () => {
        if (!formError) {
            setFormError(true);
        } else {
            const errorMessage = document.querySelector("[data-test-selector='errorMessage']") as HTMLElement;
            errorMessage?.focus();
        }
    };

    const stepProductConfiguration = (step: string, direction: "Forward" | "Backward") => {
        if (direction === "Forward") {
            const isValid = validateFields();
            if (!isValid) {
                onFormError();
                return;
            }
        }

        setFormError(false);
        setVisibleSection(undefined);
        const configId: string = productConfigState!.value!.id;

        stepProductConfig({
            productId,
            configId,
            step,
            onException: onApiError,
            onError: onUnknownError,
        });
    };

    const onChangeHandler = (parameter: string, value: string) => {
        const configId: string = productConfigState!.value!.id;

        commitProductConfig({
            productId,
            configId,
            value,
            parameter,
            onException: onApiError,
            onError: onUnknownError,
        });

        setScrollPosition(window.scrollY);
    };

    const cancelProductConfigurationClick = () => {
        const configId = productConfigState?.value?.id;

        // This situation would occur if the start product config step would fail to load
        if (configId) {
            cancelProductConfig({
                configId,
                productId,
            });
        }
        setCancelConfigurationModalVisible(false);
        onAllChangesSaved();
        onClick(history, navigateLink);
    };

    const onHomeClickHandler = () => {
        setNavigateLink("/");
        if (unsavedChanges) {
            setCancelConfigurationModalVisible(true);
        } else {
            cancelProductConfigurationClick();
        }
    };

    const onCancelClickHandler = () => {
        setNavigateLink(returnUrl);
        if (unsavedChanges) {
            setCancelConfigurationModalVisible(true);
        } else {
            cancelProductConfigurationClick();
        }
    };

    const onCartClickHandler = (url?: string | undefined) => {
        if (url) {
            setNavigateLink(url);
            if (unsavedChanges) {
                setCancelConfigurationModalVisible(true);
            } else {
                cancelProductConfigurationClick();
            }
        }
    };

    const onSaveClickHandler = () => {
        const productInfo = createFromProduct(product.value!);
        setAddToListModalIsOpen({
            modalIsOpen: true,
            productInfos: [productInfo],
            configId: productConfigState.value!.id,
        } as any);
    };

    const onGroupClickHandler = (groupName: string) => {
        document.getElementById(groupName)?.scrollIntoView({ behavior: "auto" });
        if (navOpen) {
            window.scroll(0, window.scrollY - 60);
        }
        setVisibleSection(groupName);
        setNavOpen(false);
    };

    const onUncommitHandler = (parameter: string) => {
        const configId: string = productConfigState!.value!.id;

        uncommitProductConfig({
            productId,
            configId,
            parameter,
            onException: onApiError,
            onError: onUnknownError,
        });
    };

    const onBlurHandler = (e: React.FocusEvent) => {
        const activeElement = e.relatedTarget as Element;
        const focusTargetIsChild = dropdownRef.current?.contains(activeElement as Node);
        const focusTargetIsExitButton = activeElement?.nodeName.toLowerCase() === "button";
        if (focusTargetIsChild && !focusTargetIsExitButton) {
            return;
        }
        setNavOpen(false);
    };

    const onKeyDownHandler = (e: React.KeyboardEvent, name: string) => {
        const key = e.nativeEvent.code.toLowerCase();
        if (key === "enter" || key === "space") {
            e.preventDefault();
            const target = e.target as Element;
            if (target.nodeName.toLowerCase() === "li" || target.nodeName.toLowerCase() === "span") {
                onGroupClickHandler(name);
                document.getElementById(name)?.focus();
            } else {
                setNavOpen(!navOpen);
            }
        } else if (key === "arrowdown" || key === "arrowup") {
            e.preventDefault();
            const selectedStep = productConfigState?.value?.steps.find((step: StepModel) => step.current);
            const selector = `li[data-name='${selectedStep?.name}']`;
            const selectItems = [...document.querySelectorAll(selector)] as HTMLElement[];
            moveFocus(key, selectItems, false);
        } else if ((key === "tab" || key === "escape") && navOpen) {
            setNavOpen(false);
        }
    };

    const resolveConflict = () => {
        const configId: string = productConfigState!.value!.id;
        const parameter = conflictDetails?.name;
        const value = conflictDetails?.newValue;

        resolveProductConfig({
            productId,
            configId,
            value,
            parameter,
            onException: onApiError,
            onError: onUnknownError,
        });
        setHasConflict(false);
    };

    const validateFields = () => {
        const results: boolean[] = [];
        Object.keys(validators).forEach(key => {
            const validator = validators[key];
            if (validator) {
                results.push(validator());
            }
        });
        return results.every(o => o);
    };

    const isPreventGoingToNextStep = () => {
        let disabledInputs = 0;
        let totalInputs = 0;

        selectedStep?.groups.forEach((group: any) => {
            group?.rows.forEach((row: any) => {
                totalInputs = totalInputs + row.inputs?.length;
                row?.inputs.forEach((input: any) => {
                    if (input?.disabled) {
                        disabledInputs++;
                    }
                });
            });
        });
        preventGoingNextStep = totalInputs === disabledInputs;
    };

    isPreventGoingToNextStep();

    const afterNav = React.createRef<HTMLSpanElement>();

    return (
        <>
            <GridContainer gap={0} {...styles.gridContainerStyles}>
                <GridItem width={[0, 0, 0, 2, 2]}>
                    <UnorderedList {...styles.listContainerStyles}>
                        <SkipNav text={translate("Skip to main content")} destination={afterNav} />
                        <ListItem {...styles.huskyLogoStyles}>
                            <Clickable
                                onClick={onHomeClickHandler}
                                aria-label={translate("Husky Logo - Go to Home Page")}
                            >
                                <Icon height={40} width={200} src={HuskyLogo} aria-hidden={true} />
                            </Clickable>
                        </ListItem>
                        {productConfigState?.value?.steps.map((step, index) => (
                            <ListItem {...styles.listItemStyles} key={`${step.name}-${index}`}>
                                {step.current ? (
                                    <>
                                        <Typography {...styles.selectedItemStyles}>
                                            <span>{step.description}</span>
                                        </Typography>
                                        {step.groups && (
                                            <UnorderedList {...styles.groupStyles}>
                                                {step.groups.map((group, index) => (
                                                    <ListItem
                                                        {...styles.groupItemStyles}
                                                        key={`${group.name}-${index}`}
                                                    >
                                                        <GroupItem
                                                            tabIndex={0}
                                                            onClick={() => onGroupClickHandler(group.name)}
                                                            onKeyDown={e => onKeyDownHandler(e, group.name)}
                                                            current={group.name === visibleSection}
                                                        >
                                                            {group.description}
                                                        </GroupItem>
                                                    </ListItem>
                                                ))}
                                            </UnorderedList>
                                        )}
                                    </>
                                ) : (
                                    <Typography {...styles.groupNavStyles}>{step.description}</Typography>
                                )}
                            </ListItem>
                        ))}
                    </UnorderedList>
                </GridItem>
                <GridItem width={[12, 12, 12, 10, 10]} style={{ flexDirection: "column" }}>
                    <StyledWrapper {...styles.actionsContainerStyles}>
                        <Hidden above="md">
                            <SkipNav text={translate("Skip to main content")} destination={afterNav} />
                            <Clickable
                                onClick={onHomeClickHandler}
                                aria-label={translate("Husky Logo - Go to Home Page")}
                            >
                                <Icon height={28} width={148} src={HuskyLogo} aria-hidden={true} />
                            </Clickable>
                        </Hidden>
                        <Clickable {...styles.saveContainer} onClick={onSaveClickHandler}>
                            <Icon {...styles.saveIcon} />
                            <Hidden below="md">
                                <Typography {...styles.saveText}>{translate("Save to List")}</Typography>
                            </Hidden>
                        </Clickable>
                        <CartLinkComponent
                            extendedStyles={styles.cartLinkStyles}
                            onBeforeNavigate={onCartClickHandler}
                        />
                        <Hidden below="lg">
                            <Clickable
                                {...styles.cancelIcon}
                                onClick={onCancelClickHandler}
                                aria-label={translate("Exit Product Configuration")}
                            >
                                <Icon src={X} />
                            </Clickable>
                        </Hidden>
                    </StyledWrapper>
                    <Hidden above="md" {...styles.navBarMobileHiddenStyles}>
                        <StyledWrapper {...styles.navBarMobileStyles} ref={dropdownRef} onBlur={onBlurHandler}>
                            {productConfigState?.value?.steps.map((step, index) => (
                                <React.Fragment key={`${step.name}-${index}`}>
                                    {step.current ? (
                                        <>
                                            <StyledWrapper
                                                role="button"
                                                tabIndex={0}
                                                {...styles.dropdownTextStyles}
                                                onClick={() => setNavOpen(!navOpen)}
                                                onKeyDown={e => onKeyDownHandler(e, "")}
                                                aria-expanded={navOpen}
                                                aria-label={`${translate("Navigate to Form Section")} - ${
                                                    navOpen ? translate("Collapse Menu") : translate("Expand Menu")
                                                }`}
                                            >
                                                <Typography {...styles.selectedItemStyles}>{visibleSection}</Typography>
                                                <Icon
                                                    src={navOpen ? ChevronUp : ChevronDown}
                                                    {...styles.chevronIconStyles}
                                                />
                                            </StyledWrapper>

                                            {step.groups && navOpen && (
                                                <NavList>
                                                    {step.groups.map((group: GroupModel, index: number) => (
                                                        <ListItem
                                                            data-name={step.name}
                                                            {...styles.groupItemStyles}
                                                            tabIndex={0}
                                                            onClick={() => onGroupClickHandler(group.name)}
                                                            onKeyDown={e => onKeyDownHandler(e, group.name)}
                                                            key={`${group.name}-${index}`}
                                                        >
                                                            <GroupItemMobile current={group.name === visibleSection}>
                                                                {group.description}
                                                            </GroupItemMobile>
                                                        </ListItem>
                                                    ))}
                                                </NavList>
                                            )}
                                            <Clickable
                                                {...styles.dropdownExitStyles}
                                                onClick={onCancelClickHandler}
                                                aria-label={translate("Exit Product Configuration")}
                                            >
                                                {translate("Exit")}
                                                <Icon src={X} {...styles.cancelIconMobileStyles} />
                                            </Clickable>
                                        </>
                                    ) : null}
                                </React.Fragment>
                            ))}
                        </StyledWrapper>
                    </Hidden>
                    <LoadingOverlay {...styles.loadingOverlay} loading={productConfigState.isLoading || isAddingToCart}>
                        <GridContainer
                            data-test-selector="afterNav"
                            tabIndex={-1}
                            {...styles.mainContentContainerStyles}
                        >
                            <span ref={afterNav} tabIndex={-1} />
                            {formError && (
                                <GridItem width={12 as GridWidths}>
                                    <Typography
                                        tabIndex={-1}
                                        data-test-selector="errorMessage"
                                        {...styles.errorMessageStyles}
                                    >
                                        {cmsProps.formErrorText}
                                    </Typography>
                                </GridItem>
                            )}
                            {selectedStep && (
                                <>
                                    <GridItem width={12 as GridWidths}>
                                        <Typography tabIndex={-1} data-id="PageTitle" {...styles.stepTextStyles}>
                                            {selectedStep.description}
                                        </Typography>
                                    </GridItem>
                                    {selectedStep?.groups.map((group: GroupModel, index: number) => (
                                        <React.Fragment key={`${group.name}-${index}`}>
                                            <GridItem
                                                width={12 as GridWidths}
                                                {...(index !== 0 ? styles.groupDividerStyles : styles.hiddenStyles)}
                                            >
                                                <hr />
                                            </GridItem>
                                            <GridItem width={12 as GridWidths}>
                                                <GroupText
                                                    tabIndex={-1}
                                                    ref={ref => {
                                                        if (ref) {
                                                            refsArray.current[index] = ref;
                                                        }
                                                    }}
                                                    id={group.name}
                                                >
                                                    <Typography {...styles.groupTextStyles}>
                                                        {group.description}
                                                    </Typography>
                                                </GroupText>
                                            </GridItem>
                                            {group.rows &&
                                                group?.rows.map((row: any, index: number) => (
                                                    <React.Fragment key={`${row.rowName}-${index}`}>
                                                        {row.inputs &&
                                                            row.inputs.map((input: any, index: number) => (
                                                                <React.Fragment key={`${input.name}-${index}`}>
                                                                    <GridItem
                                                                        width={[
                                                                            0,
                                                                            0,
                                                                            0,
                                                                            input.colOffset as GridWidths,
                                                                            input.colOffset as GridWidths,
                                                                        ]}
                                                                    ></GridItem>
                                                                    <GridItem
                                                                        width={[
                                                                            12,
                                                                            12,
                                                                            12,
                                                                            input.colSpan as GridWidths,
                                                                            input.colSpan as GridWidths,
                                                                        ]}
                                                                        {...styles.inputContainerStyles}
                                                                    >
                                                                        <ProductConfigViewContext.Provider
                                                                            value={{ validators }}
                                                                        >
                                                                            <TactonInput
                                                                                cssHideOrange={cmsProps.cssHideOrange}
                                                                                input={input}
                                                                                onChange={onChangeHandler}
                                                                                onUncommit={onUncommitHandler}
                                                                            />
                                                                        </ProductConfigViewContext.Provider>
                                                                    </GridItem>
                                                                </React.Fragment>
                                                            ))}
                                                        <GridItem
                                                            style={{ padding: 0 }}
                                                            width={12 as GridWidths}
                                                        ></GridItem>
                                                    </React.Fragment>
                                                ))}
                                        </React.Fragment>
                                    ))}
                                </>
                            )}
                        </GridContainer>
                        {productConfigState.value && (
                            <TactonConfigFooter
                                productId={productId}
                                configuration={productConfigState?.value}
                                selectedStep={selectedStep}
                                cmsProps={cmsProps}
                                onStepChange={stepProductConfiguration}
                                validator={validateFields}
                                isLoading={productConfigState.isLoading || isAddingToCart}
                                onAddingToCart={setIsAddingToCart}
                                preventGoingNextStep={preventGoingNextStep}
                            ></TactonConfigFooter>
                        )}
                    </LoadingOverlay>
                </GridItem>
            </GridContainer>
            <TwoButtonModal
                headlineText={translate("Exit")}
                messageText={translate(
                    'Are you sure you want to exit? Your changes will not be saved. If you would like to save before exiting, click "No" and then Save.',
                )}
                cancelButtonText={translate("No")}
                submitButtonText={translate("Yes")}
                modalIsOpen={cancelConfigurationModalVisible}
                onCancel={() => setCancelConfigurationModalVisible(false)}
                onSubmit={cancelProductConfigurationClick}
                extendedStyles={styles.modalStyles}
            ></TwoButtonModal>
            <TwoButtonModal
                headlineText={translate("Conflict")}
                messageText={conflictDetails?.message}
                cancelButtonText={translate("Cancel")}
                submitButtonText={translate("Resolve")}
                modalIsOpen={hasConflict}
                onCancel={() => setHasConflict(false)}
                onSubmit={resolveConflict}
                extendedStyles={styles.modalStyles}
            ></TwoButtonModal>
            <Modal
                handleClose={() => setHasApiError(false)}
                headline={translate("Error")}
                isCloseable={true}
                isOpen={hasApiError}
                {...styles.modalStyles?.modal}
            >
                {translate("There was an error completing your request. Please try again.")}
            </Modal>
            <Modal
                handleClose={onUnknownErrorModalClose}
                headline={translate("Error")}
                isCloseable={true}
                isOpen={hasUnknownError}
                {...styles.modalStyles?.modal}
            >
                {cmsProps.errorText}
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ProductConfigView)),
    definition: {
        displayName: "Configure",
        group: "Husky Custom" as any,
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.priceText,
                displayName: "Price Text",
                editorTemplate: "TextField",
                defaultValue: "Estimated Payment",
                fieldType: "Translatable",
            },
            {
                name: fields.leadTimeText,
                displayName: "Lead Time Text",
                editorTemplate: "TextField",
                defaultValue: "Estimated Lead Time",
                fieldType: "Translatable",
            },
            {
                name: fields.estimatedLeadTime,
                displayName: "Estimated Lead Time",
                editorTemplate: "TextField",
                defaultValue: "2-3 Weeks",
                fieldType: "Translatable",
            },
            {
                name: fields.rfqText,
                displayName: "RFQ Text",
                editorTemplate: "TextField",
                defaultValue: "Please complete your configuration and request a quote.",
                fieldType: "Translatable",
            },
            {
                name: fields.errorText,
                displayName: "Error Text",
                editorTemplate: "TextField",
                defaultValue: "We're sorry. We've encountered an unexpected error.",
                fieldType: "Translatable",
            },
            {
                name: fields.formErrorText,
                displayName: "Form Error Text",
                editorTemplate: "TextField",
                defaultValue:
                    "There are errors in the form. Please complete all required fields and correct any errors before resubmitting.",
                fieldType: "Translatable",
            },
            {
                name: fields.cssHideOrange,
                displayName: "css_hide_orange",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
